import { useState, useEffect } from "react"
import LogoUrl from "../../assets/Logo.png"
import LogoutIcon from "../../assets/Logout.png"
import LogoWhiteUrl from "./arrow-icon-blume-midnight-grey.png"
import { Bar } from "./AppBar.styles"
import { useAppDispatch, useAppSelector } from "../../app/hooks"
import { openInvoices, openSettings, openReporting } from "../../activeScreenSlice"
import { Box, Typography, useTheme } from "@mui/material"
import Button from "../Button/Button"
import { UserRole } from "../../api/generated"
import { StyledTabs, Tab } from "../../components/Tabs/Tabs.styles"
import { selectActivePage } from "../../activeScreenSlice"

export interface Props {
  variant: "landing"| "login" | UserRole
  name?: string
  showSettings: boolean
  role?: UserRole | string
  isTokenValid?: boolean
  onLogoutClick: () => void
}

function logoToUse(variant: "landing" | "login" | UserRole) {
  if (variant === "landing") {
    return LogoWhiteUrl
  }
  return LogoUrl
}

export default function AppBar(props: Props) {
  const dispatch = useAppDispatch()
  const activePage = useAppSelector(selectActivePage)
  const [tab, setTab] = useState("myinvoices")
  const theme = useTheme();

  useEffect(() => {
    if (activePage.activeScreen === "invoices") {
      setTab("myinvoices");
    }
  }, [activePage]);

  return (
    <Bar variant={props.variant} sx={{height: "28px", borderBottom: props.isTokenValid ? "1px solid #E5E5E5" : "0"}}>
      <img
        alt="Arrow logo"
        src={logoToUse(props.variant)}
        width={"28px"}
        height={"28px"}
        onClick={() => {
          if(props.isTokenValid ) {
            dispatch(openInvoices())
          }
        }}
      />
      <Typography variant="h5" sx={{ml: '6px', mt: '5px', lineHeight: '16px',fontSize: '16px', fontWeight: '700', color: theme.palette.primary.main}}>
        Arrow
      </Typography>
      {props.isTokenValid && 
        <StyledTabs
          TabIndicatorProps={{ style: {backgroundColor: '#392e85',
            height: 2,
            borderRadius: 0, } }}
          sx={{ marginLeft: "0", paddingLeft: '40px' }}
          value={tab}
          onChange={(_, value) => {
            if (value === "myinvoices") {
              dispatch(openInvoices())
            } else if (value === "reporting") {
              dispatch(openReporting())
            }
            setTab(value)
          }
        }>
    
        <Tab sx={{padding: "0 10px", fontSize: '14px', color: theme.palette.text.primary, fontWeight: "500", minHeight: "39px", mr: '16px'}} label="My Invoices" value="myinvoices" />
        {props.role?.toLowerCase() !== UserRole.USER && <Tab sx={{padding: "0 10px", fontSize: '14px', color: theme.palette.text.primary, fontWeight: "500", minHeight: "39px"}} label="Reporting" value="reporting" />}
      </StyledTabs>
      }
      <Box sx={{ display: "flex", flexDirection: "row", marginLeft: 'auto', }}>
        {props.isTokenValid  && props.showSettings && (
          <Box className="logout">
            <Button
              sx={{ height: "27px", minWidth: 'auto', borderRadius: '6px', padding: '10px 20px',}}
              icon="gear"
              onClick={() => {
                dispatch(openSettings())
                setTab(null);
              }}
            />
            </Box>
        )}
        
        {props.isTokenValid  && props.name && (
          <Typography variant="body1" sx={{lineHeight: '27px', fontWeight: 500, mr: '10px', textTransform: 'capitalize'}}>{props.name}</Typography>
        )}

        {props.isTokenValid &&
          <Button
            sx={{ height: "29px",  pr: '3px', fontWeight: 600, borderRadius: '6px' }}
            variant="textOnly"
            label="Logout"
            onClick={props.onLogoutClick}
            icon="logout"
          />
        }
      </Box>
    </Bar>
  )
}
